<template>
  <div>
    <!-- 业务初步处理 -->
    <el-dialog title="业务初步处理" :close-on-click-modal="false" :visible.sync="dialogVisible" width="680px" center>
      <div class="content">
        <el-form :model="form" :rules="rules" ref="form" label-width="130px">
          <!-- *问题图片： -->
          <el-form-item label="处理截图:">
            <div class="image">
              <div v-for="(item, index) in form.biz_images" :key="index" class="image-item">
                <img :src="item" class="avatar" />
                <i class="el-icon-error" @click="removeImage(index)"></i>
              </div>
              <el-upload class="avatar-uploader" action="/api/upload" :show-file-list="false" list-type="picture-card"
                :before-upload="beforeAvatarUpload" :http-request="httpup" multiple>
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <!-- *售后问题说明 -->
          <el-form-item label="业务处理方案:" prop="biz_solution">
            <el-input v-model="form.biz_solution" placeholder="业务处理方案" type="textarea" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        biz_images: [],
        biz_solution: '',
      },
      rules: {
        biz_images: [{ required: true, message: '请上传问题图片', trigger: 'blur' }],
        biz_solution: [{ required: true, message: '请输入售后问题说明', trigger: 'blur' }],

      },
      dialogVisible: false,

    };
  },
  methods: {
    // 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration.aftersaleIssueBizHandle(this.form).then(res => {
            this.$message.success(res.msg);
            this.$parent.aftersaleIssueList();
            this.$parent.aftersaleIssueStatusStatistics();
            this.dialogVisible = false;
          })
        } else {
          this.$message.error('请填写完整信息');
        }
      })
    },
    // 删除沟通截图
    removeImage(index) {
      this.form.biz_images.splice(index, 1);
    },
    // 上传沟通截图前
    beforeAvatarUpload(file) {
      if (this.form.biz_images.length >= 6) {
        this.$message.error('最多上传6 张业务处理截图!');
        return false;
      }
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isSVG = file.type === 'image/svg+xml';
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error('上传业务处理截图只能是 JPG/PNG/SVG 格式!');
      }
      return isJPG || isPNG || isSVG;
    },
    // 上传沟通截图
    // 图片上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.form.biz_images.push(data.data)
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;

    .input {
      width: 300px;
      margin-right: 20px;
    }
  }

  .image {
    display: flex;
    flex-wrap: wrap;

    .image-item {
      position: relative;
      margin-bottom: 10px;
      margin-right: 10px;

      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -5px;
        font-size: 20px;
        color: #ff4949;
        cursor: pointer;
      }
    }

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 4px;

    }
  }

  .avatar-uploader {
    height: 80px;
    width: 80px;
  }

  /deep/.el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }

  /deep/.el-textarea__inner {
    height: 100px;
  }

  .list {
    margin-top: 10px;

    p {
      line-height: 30px;
    }
  }
}
</style>